import { replaceUriParameter } from "api/endpoints";
import { useQuery } from "@tanstack/react-query";
import { RestEndpoints } from "../../../api/endpoints";
import { ReactQueryConfig } from "../../../config/react-query-config";
import getInstance from "../../../utils/rest";
import { GroupConverter } from "../../../domain/converter/group.converter";
import { IGroup } from "../../../domain/group/group";
import { SharedQueryKeys } from "../query-keys";
import { IGroupModel } from "./../../../models/group/group.model";

const getGroupForDetails = async (erpNumber: string): Promise<IGroup> => {
  const url = replaceUriParameter(RestEndpoints.GroupForDetailView, "erpNumber", erpNumber);
  const response = await getInstance().get<IGroupModel>(url);
  return GroupConverter.toDomain(response.data);
};

export const useGetGroupForDetailsQuery = (erpNumber: string) => {
  return useQuery({
    queryKey: [SharedQueryKeys.GetGroupForDetails, erpNumber],
    queryFn: () => getGroupForDetails(erpNumber),
    staleTime: ReactQueryConfig.staleTime,
  });
};
